<script setup lang="ts">
import { ref } from "vue";
import { type Game, useGameStore } from "@/stores/games.ts";
import TeamSelect from "@/components/form/TeamSelect.vue";

const gameStore = useGameStore();

const newGame = ref<Game>({
  id: "",
  dateTime: new Date().toISOString(),
  teams: {
    home: {
      id: "",
      game: null,
      placement: null,
    },
    away: {
      id: "",
      game: null,
      placement: null,
    },
  },
  score: null
});

function save(game_id: string) {
  const game = gameStore.games.find(g => g.id === game_id);
  if (!game) return;
  gameStore.put(game);
}

</script>

<template>
  <div class="page">
    <div class="game-edit panel">
      <h2>Spiele bearbeiten</h2>
      <table>
        <thead>
          <tr>
            <th>NR</th>
            <th>Datum</th>
            <th>Heim</th>
            <th>Gast</th>
            <th>Löschen</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(game, index) in gameStore.games" :key="game.id">
            <td>#{{ index + 1 }}</td>
            <td>
              <input
                class="l2"
                :value="new Date(new Date(game.dateTime).getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16)"
                type="datetime-local"
                @input="($event) => {
                  const target = $event.target as HTMLInputElement;
                  game.dateTime = new Date(target.value).toISOString();
                  save(game.id);
                }"
              />
            </td>
            <td>
              <TeamSelect v-model="game.teams.home" @input-change="save(game.id)" />
            </td>
            <td>
              <TeamSelect v-model="game.teams.away" @input-change="save(game.id)"/>
            </td>
            <td>
              <button @click="gameStore.remove(game)" class="l2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="game-create panel">
      <h2>Neues Spiel erstellen</h2>
      <form @submit.prevent="gameStore.put(newGame)">
        <label>
          Datum:
          <input v-model="newGame.dateTime" type="datetime-local" class="l2" />
        </label>
        <label>
          Heimmannschaft:
          <TeamSelect v-model="newGame.teams.home" />
        </label>
        <label>
          Gastmannschaft:
          <TeamSelect v-model="newGame.teams.away" />
        </label>
        <button type="submit" class="l2">Create Game</button>
      </form>
    </div>
  </div>
</template>

<style scoped>

.game-edit {
  overflow-x: auto;
  &.panel {
    max-width: 75rem;
  }

  td {
    text-align: center;
    vertical-align: middle;

    input {
      width: 100%;
    }
  }
}

.game-create form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
